module.exports = __webpack_public_path__ + "static/media/MuseoSans-100.900b5dcc.ttf";